// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__8KTeT","range":"MonthRangeSwitch_range__3g1lf","disabled":"MonthRangeSwitch_disabled__2W8CN"};